var _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgVisibility(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 21,
    height: 14,
    viewBox: "0 0 21 14",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "icon-visibility",
    d: "M20.873,10.968A11.694,11.694,0,0,0,10.5,4.5,11.7,11.7,0,0,0,.127,10.968a1.179,1.179,0,0,0,0,1.064A11.694,11.694,0,0,0,10.5,18.5a11.7,11.7,0,0,0,10.373-6.468A1.179,1.179,0,0,0,20.873,10.968ZM10.5,16.75a5.25,5.25,0,1,1,5.25-5.25A5.25,5.25,0,0,1,10.5,16.75ZM10.5,8a3.475,3.475,0,0,0-.923.138,1.745,1.745,0,0,1-2.439,2.439A3.492,3.492,0,1,0,10.5,8Z",
    transform: "translate(0 -4.5)",
    fill: "#9e9e9e"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgVisibility);
export default __webpack_public_path__ + "static/media/visibility.d2f83a0b52fa94bc3dc87b3606d17e1c.svg";
export { ForwardRef as ReactComponent };